import { Dispatch, SetStateAction, useMemo } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { useAvailableClients } from '../../hooks/utils/useAvailableClients';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function CreatedBy({ query, setQuery, editable = false }: Props) {
  const clients = useAvailableClients();
  const options = useMemo(
    () => [
      {
        label: 'Anyone',
        value: undefined,
      },
      {
        label: 'Me',
        value: 'self',
      },
      ...clients.map((client) => ({
        label: client.DisplayName,
        value: client.ID,
      })),
    ],
    [clients]
  );

  const state = getCreatedBy(query);
  const value = options.find((option) => option.value === state) ?? options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setCreatedBy(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Created by"
      description="Filter applications by creator"
      disabled={!editable}
      filterable
    />
  );
}

function setCreatedBy(by: Value): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    SummaryCreatedBy: by,
  });
}

function getCreatedBy(query: ace_index.FindInput) {
  return query.SummaryCreatedBy ?? '';
}

type Value = ace_index.FindInput['SummaryCreatedBy'];
